import { createRouter, createWebHistory } from 'vue-router'
import { loadLayoutMiddleware } from '@/router/middleware/loadLayoutMiddleware.js'
import { authMiddleware } from '@/router/middleware/auth.js'
import { maintenanceModeMiddleware } from '@/router/middleware/maintenanceMode.js'
import { utmTrackingMiddleware } from '@/router/middleware/utmTracking.js'
import { redirectMiddleware } from '@/router/middleware/redirects.js'

const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: () => import('../views/Dashboard.vue')
    },
    {
      path: '/full-catalogue',
      name: 'full-catalogue',
      component: () => import('../views/CatalogueView.vue'),
      meta: {
        title: 'FULL CATALOGUE',
        subtitle: 'Choose the category you wish to browse below.',
        categoryGetter: 'mySmiMenu/rootMenuItems',
        scope: 'full',
        isUserCatalogue: false
      }
    },
    {
      path: '/my-catalogue',
      name: 'my-catalogue',
      component: () => import('../views/CatalogueView.vue'),
      meta: {
        title: 'MY CATALOGUE',
        subtitle: 'Choose the category you wish to browse below.',
        categoryGetter: 'mySmiMenu/rootMyMenuItems',
        scope: 'my',
        isUserCatalogue: false
      }
    },
    {
      path: '/user-catalogues',
      name: 'user-catalogues',
      component: () => import('../views/CatalogueView.vue'),
      meta: {
        title: 'USER CATALOGUES',
        subtitle: 'Choose the catalogue you wish to order for below.',
        categoryGetter: 'mySmiMenu/rootMenuItems',
        isUserCatalogue: true
      }
    },
    {
      path: '/product/:productSlug',
      name: 'single-product',
      component: () => import('../views/SingleProduct.vue'),
    },

    // All catalogues root - shows all products across all categories
    {
      path: '/categories/all',
      name: 'all-products-root',
      component: () => import('../views/ProductListV2.vue'),
      exact: true
    },

    // All catalogues (combined scope - shows all products user can see)
    {
      path: '/categories/all/:fullSlug(.*)+',
      name: 'all-product-cats',
      component: () => import('../views/ProductListV2.vue'),
    },

    // My and Full catalogues
    {
      path: '/categories/:prefix(my|full)/:fullSlug(.*)*',
      name: 'product-cats',
      component: () => import('../views/ProductList.vue'),
    },

    // User-specific catalogues
    {
      path: '/categories/user/:catalogueId/:fullSlug(.*)*',
      name: 'user-product-cats',
      component: () => import('../views/ProductList.vue'),
    },

    {
      path: '/product-category',
      name: 'product-category',
      component: () => import('../views/ProductList.vue')
    },
    {
      path: '/basket',
      name: 'basket',
      component: () => import('../views/Basket.vue'),
      meta: {
        layout: 'BasketLayout'
      }
    },
    {
      path: '/punchedout-baskets',
      name: 'punchout baskets',
      component: () => import('../views/punchedoutBaskets.vue'),
 
    },
    {
      path: '/checkout',
      name: 'checkout',
      component: () => import('../views/Checkout.vue'),
      meta: {
        layout: 'BasketLayout'
      }
    },
    {
      path: '/order-complete',
      name: 'order-complete',
      component: () => import('../views/OrderComplete.vue'),
    },
    {
      path: '/order-history',
      name: 'order-history',
      component: () => import('../views/OrderHistory.vue'),
    },
    {
      path: '/order-to-approve',
      name: 'order-to-approve',
      component: () => import('../views/OrderApprove.vue'),
    },
    {
      path: '/wearer-pack',
      name: 'wearer-pack',
      component: () => import('../views/WearerPack.vue')
    },
    {
      path: '/reporting',
      name: 'reporting',
      component: () => import('../views/Reporting.vue'),
    },
    {
      path: '/add-wearer',
      name: 'add-wearer',
      component: () => import('../views/NewWearer.vue'),
    },
    {
      path: '/remove-wearer',
      name: 'remove-wearer',
      component: () => import('../views/RemoveWearer.vue'),
    },
    {
      path: '/add-site-user',
      name: 'add-site-user',
      component: () => import('../views/NewSiteUser.vue'),
    },
    {
      path: '/add-delivery-address',
      name: 'add-delivery-address',
      component: () => import('../views/NewDeliveryAddress.vue'),
    },
    {
      path: '/manage-delivery-addresses',
      name: 'manageAdresses',
      component: () => import('../views/manageAddresses.vue'),
    },
      {
      path: '/cms/download',
      name: 'Training Guides',
      component: () => import('../views/download.vue'),
    },
    {
      path: '/my-account',
      name: 'my-account',
      component: () => import('../views/MyAccount.vue'),
    },
    {
      path: '/news',
      name: 'news',
      component: () => import('../components/cms/article.vue'),
    },
    {
      path: '/news/:slug',
      name: 'NewsArticle',
      component: () => import('../components/cms/pages/ContentArticle.vue')
    },
    {
      path: '/dashboard',
      name: 'dashboard-alt',
      component: () => import('../views/Dashboard.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('../views/Login.vue'),
      meta: {
        layout: 'LoginLayout'
      }
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import('../views/Maintenance.vue'),
      meta: {
        layout: 'LoginLayout'
      }
    },
    {
      path: '/punchout-only',
      name: 'punchout-only',
      component: () => import('../views/PunchoutOnly.vue'),
      meta: {
        layout: 'LoginLayout'
      }
    },
    {
      name: 'select-business-unit-entity',
      path: '/select-your-customer',
      component: () => import('../views/businessUnits.vue'),
      meta: {
        layout: 'LoginLayout'
      }
    },
    {
      path: '/customer/forgot',
      name: 'forgot',
      component: () => import('../views/Forgot.vue'),
      meta: {
        layout: 'LoginLayout'
      }
    },
    {
      path: '/customer/reset-password/:slug',
      name: 'reset-password',
      component: () => import('../views/ResetPassword.vue'),
      meta: {
        layout: 'LoginLayout'
      }
    },
    {
      path: '/customer/invitation',
      name: 'invitation',
      component: () => import('../views/Invitation.vue'),
      meta: {
        layout: 'LoginLayout'
      }
    },
    {
      path: '/site-search',
      name: 'site-search',
      component: () => import('../views/Search.vue'),
    },
    {
      path: '/search',
      name: 'search',
      component: () => import('../views/SearchResults.vue'),
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('../views/Help.vue'),
    },
    {
      path: '/order-to-approve/:orderId',
      name: 'OrderToApprove',
      component: () => import('@/components/order-to-approve/_orderId.vue')
    },

    {
      path: '/cms/:slug',
      name: 'cms',
      component: () => import('@/components/cms/CmsPage.vue')
    },
    {
      path: '/basket/checkout-success',
      name: 'checkout-success',
      component: () => import('@/components/Basket/checkout-success.vue')
    },
    {
      path: '/order-history/:orderId',
      name: 'OrderHistory',
      component: () => import('@/components/orderHistory/_orderId.vue')
    },
    {
      path: '/order-history/:orderId/despatched/:id',
      name: 'OrderFulfilled',
      component: () => import('@/components/orderHistory/despatched/DespatchedDetail.vue')
    },
    {
      path: '/admin/active-users',
      name: '',
      component: () => import('../views/admin/active-users.vue'),
    },
    {
      path: '/admin/invitation',
      name: 'admin-invitation',
      component: () => import('../views/admin/Invitation.vue'),
    },
    {
      path: '/admin/my-catalogue',
      name: '',
      component: () => import('../views/admin/my-catalogue.vue'),
    },
    {
      path: '/admin/netsuite-pull',
      name: '',
      component: () => import('../views/admin/netsuite-pull.vue'),
    },
    {
      path: '/admin/orders',
      name: '',
      component: () => import('../views/admin/orders.vue'),
    },
    {
      path: '/admin/promo',
      name: '',
      component: () => import('../views/admin/promo.vue'),
    },
    {
      path: '/admin/sync-status',
      name: '',
      component: () => import('../views/admin/sync-status.vue'),
    },
    {
      path: '/admin/view-as',
      name: '',
      component: () => import('../views/admin/view-as.vue'),
    },
    {
      path: '/admin/user/:userId',
      name: '',
      component: () => import('../views/admin/user/_id.vue'),
    },
    {
      path: '/admin/category-manager',
      name: '',
      component: () => import('../views/admin/category-manager.vue'),
    },
    {
      path: '/admin/manage-admin-users',
      name: 'admin-manage-users',
      component: () => import('../views/admin/ManageAdminUsers.vue'),
    },
    {
      path: '/admin/login-history',
      name: 'admin-login-history',
      component: () => import('../views/admin/LoginHistory.vue'),
    },
    {
      path: '/admin/landing-pages',
      name: 'admin-landing-pages',
      component: () => import('../views/admin/LandingPages.vue'),
    },
    {
      path: '/admin/landing-pages/:id/products',
      name: 'admin-landing-page-products',
      component: () => import('../views/admin/LandingPageProducts.vue'),
    },
    {
      path: '/admin/landing-pages/:id/customers',
      name: 'admin-landing-page-customers',
      component: () => import('../views/admin/LandingPageCustomers.vue'),
    },
    {
      path: '/spotlights',
      name: 'landing-pages',
      component: () => import('../views/LandingPages.vue'),
    },
    {
      path: '/spotlights/:slug',
      name: 'landing-page',
      component: () => import('../views/LandingPage.vue'),
    },
    {
      path: '/campaigns/:slug',
      name: 'campaign-page',
      component: () => import('../views/LandingPage.vue'),
    },
    {
      path: '/promotions/:slug',
      name: 'promotion-page',
      component: () => import('../views/LandingPage.vue'),
    },
    {
      path: '/saved-baskets',
      name: '',
      component: () => import('../views/savedBasket.vue'),
    },
    {
      path: '/saved-punchout-baskets',
      name: '',
      component: () => import('../views/savedPunchoutBasket.vue'),
    },
  ]
});

router.beforeEach(redirectMiddleware);
router.beforeEach(maintenanceModeMiddleware);
router.beforeEach(loadLayoutMiddleware);
router.beforeEach(authMiddleware);
router.beforeEach(utmTrackingMiddleware);

export default router;
